import { render, staticRenderFns } from "./InstagramInstantwinApplicantFilter.vue?vue&type=template&id=2c65eae2&scoped=true"
import script from "./InstagramInstantwinApplicantFilter.vue?vue&type=script&lang=ts"
export * from "./InstagramInstantwinApplicantFilter.vue?vue&type=script&lang=ts"
import style0 from "./InstagramInstantwinApplicantFilter.vue?vue&type=style&index=0&id=2c65eae2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c65eae2",
  null
  
)

export default component.exports